module.exports = __webpack_public_path__ + "img/image12.2d6758ca.png";